<template>
	<dl class="v-file-upload__idle__criteria">
		<div class="v-file-upload__criteria__file-types">
			<dt>Allowed file types</dt>
			<dd>
				<ul>
					<li v-for="type in acceptedFileTypes" v-html="type"/>
				</ul>
			</dd>
		</div>
		<div v-if="maxKB" class="v-file-upload__criteria__max-size">
			<dt><abbr title="maximum">Max.</abbr> file size</dt>
			<dd v-html="maxFileSize.value + maxFileSize.unit"/>
		</div>
		<div v-if="maxFiles" class="v-file-upload__criteria__max-files">
			<dt><abbr title="maximum">Max.</abbr> files</dt>
			<dd v-html="maxFiles"/>
		</div>
	</dl>
</template>
<script>
export default {
	name: "v-file-upload-criteria",

	computed: {
		acceptedFileTypes() {
			return this.$parent.acceptedFileTypes;
		},
		maxKB() {
			return this.$parent.maxKB;
		},
		maxFileSize() {
			return this.$parent.maxFileSize;
		},
		maxFiles() {
			return this.$parent.maxFiles;
		},
		// acceptedMimes() {
		// 	return this.accept.split("|");
		// },
		// acceptedFileTypes() {
		// 	return _.map(this.acceptedMimes, mime => {
		// 		return this.stringer(mime).split("/").stringer(1).upper().value;
		// 	});
		// },
		//
		// maxFileSize() {
		// 	if (!this.maxKB) {
		// 		return null;
		// 	}
		// 	return this.fileSize(this.maxKB);
		// },
	},

	props: {
		// acceptedFileTypes: {
		// 	required: true,
		// 	type: String,
		// },
		// maxKB: {
		// 	required: false,
		// 	type: Number,
		// 	default() {
		// 		return null;
		// 	},
		// },
		// maxFileSizes: {},
		// maxFiles: {
		// 	required: false,
		// 	type: Number,
		// 	default() {
		// 		return 1;
		// 	},
		// },
	},
};
</script>
